import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import * as XLSX from '../../xlsx';

@Injectable()
export class SheetjsHelperService {

  private workbook;

  constructor() { }

  parseDataForSheetJs(tableData: any, noOfColumns): any[][] {
    const parsedDataForSheet: any[][] = [[]];
    let i = 0, j = 0;
    for (const row of tableData) {
      parsedDataForSheet[i] = [];
      for (const data of row) {
        if ((j === 0 && data.title === '') || (j === noOfColumns)) {
          continue;
        }
        if (data.type !== 1 || data.type !== 6 || data.type !== 5) {
          parsedDataForSheet[i][j] = data.title;
        }
        j += 1;
      }
      j = 0;
      i += 1;
    }
    return parsedDataForSheet;
  }

  prepareSheet(parsedData: any[][], noOfColumns): XLSX.WorkSheet {
    const workSheet: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(parsedData);
    let noOfHeadersFormated = 0;
    for (const cell in workSheet) {
      if (workSheet.hasOwnProperty(cell)) {
        if (cell === '!ref') {
          continue;
        }
        noOfHeadersFormated += 1;
        if (noOfHeadersFormated !== (noOfColumns + 1)) {
          workSheet[cell].bold = true;
          workSheet[cell].fillColor = true;
        } else {
          break;
        }
      }
    }

    return workSheet;
  }

  prepareWorkBook(workSheets: XLSX.WorkSheet[], headerColorHex, titles?: string[]): XLSX.WorkBook {
    /* generate workbook and add the worksheet */
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    (workbook as any).headerColor = headerColorHex;

    const hasTitles = titles && workSheets.length === titles.length;

    workSheets.forEach((workSheet, index) => {
      let title = 'Sheet' + (index + 1);

      if ( hasTitles ) {
        title = titles[index];

        // Max title char limit is 31
        if (title.length >= 30) {
          title = title.slice(0, 27) + '...';
        }
      }

      XLSX.utils.book_append_sheet(workbook, workSheet, title);
    });

    return workbook;
  }

  downloadSheet(workbook: XLSX.WorkBook, xlsxWritingOptions: XLSX.WritingOptions, fileName: string) {
    const workBookOutputBuffer: ArrayBuffer = XLSX.write(workbook, xlsxWritingOptions);
    saveAs(new Blob([workBookOutputBuffer], { type: 'application/octet-stream' }), fileName);
  }

}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/services/sheetjs-helper.service.ts